import React from "react";
import "./ExpertisesSection.css";

const ITEMS = [
  ["Conception mécanique", "Pièces, sous-ensembles et petits ensembles destinés à la fabrication."],
  ["Modélisation 3D", "Modèles exploitables, prêts pour la mise en plan et les échanges de fichiers."],
  ["Mise en plan", "Plans d'ensemble et de détail, cotation fonctionnelle, tolérances utiles."],
  ["Dossiers de fabrication", "Plans, nomenclatures et exports PDF / DXF / STEP pour l'atelier ou le sous-traitant."],
  ["Ensembles mécano-soudés", "Supports, châssis et bâtis simples, avec préparation des éléments à découper et à souder."],
  ["Structures métalliques simples", "Plateformes, passerelles, garde-corps et supports d'équipement."],
  ["Modification / reprise d'existant", "Adaptation d'une pièce ou d'un ensemble à de nouvelles contraintes."],
  ["Rétro-conception simple", "Reconstruction 3D d'une pièce existante à partir de relevés ou de plans anciens."],
  ["Renfort ponctuel de bureau d'études", "Appui sur une surcharge, un dossier à reprendre ou à finaliser."],
];

// Viewports retain the approved models exactly, excluding the board's labels.
const MODEL_VIEWPORTS = [
  [0, 112, 340, 340], [340, 112, 340, 340], [680, 112, 344, 340],
  [0, 550, 340, 348], [340, 550, 340, 348], [680, 550, 344, 348],
  [0, 995, 340, 372], [340, 995, 340, 372], [680, 995, 344, 372],
];

const PHOTO_MODELS = {
  4: {
    src: "/img/ensemble-mecano-soude-reference.jpg",
    alt: "Bâti mécano-soudé en acier avec traverses, renforts et platines de fixation",
    width: 1024,
    height: 687,
  },
  6: {
    src: "/img/modification-reprise-existant-photo.jpg?v=piece-usagee-20261009",
    alt: "Illustration d'un palier mécanique usagé avec traces d'usure",
    width: 1448,
    height: 1086,
  },
};

const ExpertisesSection = () => (
  <section className="expertises s-section" id="expertises" aria-labelledby="expertises-title" data-testid="expertises-section">
    <div className="s-container">
      <div className="expertises-head">
        <div className="reveal">
          <p className="s-label">Expertises</p>
          <h2 id="expertises-title" className="s-title">
            Des compétences maîtrisées,
            <br />
            orientées fabrication.
          </h2>
        </div>
        <p className="s-lead reveal" data-delay="1">
          SI2T se concentre sur des prestations de conception et de mise en plan qu'il maîtrise, pour répondre à
          des besoins concrets de TPE et PME industrielles : du croquis au dossier technique. L'objectif est de
          préparer des projets documentés, prêts à être soumis aux intervenants disposant des qualifications ou
          certifications requises pour les calculs, les vérifications de conformité aux normes et les validations
          nécessaires.
        </p>
      </div>

      <div className="expertises-grid">
        <ol className="expertises-list" data-testid="expertises-list">
          {ITEMS.map(([title, desc], i) => (
            <li key={title} className="expertises-item reveal" data-delay={(i % 3) + 1} data-testid={`expertise-item-${i + 1}`}>
              {PHOTO_MODELS[i] ? (
                <img
                  className="expertises-model expertises-model-photo"
                  src={PHOTO_MODELS[i].src}
                  alt={PHOTO_MODELS[i].alt}
                  width={PHOTO_MODELS[i].width}
                  height={PHOTO_MODELS[i].height}
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <svg className="expertises-model" viewBox={MODEL_VIEWPORTS[i].join(" ")} aria-hidden="true" focusable="false">
                  <defs>
                    <clipPath id={`expertise-model-clip-${i}`}>
                      <rect x={MODEL_VIEWPORTS[i][0]} y={MODEL_VIEWPORTS[i][1]} width={MODEL_VIEWPORTS[i][2]} height={MODEL_VIEWPORTS[i][3]} />
                    </clipPath>
                  </defs>
                  <image href="/img/expertises-3d-approved.png" width="1024" height="1536" clipPath={`url(#expertise-model-clip-${i})`} />
                </svg>
              )}
              <div className="expertises-copy">
                <span className="expertises-num">{String(i + 1).padStart(2, "0")}</span>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            </li>
          ))}
        </ol>
        <p className="expertises-note">Visuels illustratifs générés.</p>
      </div>

      <aside className="expertises-scope reveal" data-testid="expertises-scope">
        <span className="expertises-scope-label">Périmètre</span>
        <p>
          Les lignes de production automatisées complexes, la robotique avancée, les machines spéciales complexes
          et les calculs ou certifications non démontrés ne font pas partie de l'offre SI2T. Les calculs réglementaires,
          vérifications de conformité et validations requises restent du ressort des intervenants habilités selon le projet.
        </p>
      </aside>
    </div>
  </section>
);

export default ExpertisesSection;
